import {useApiWrite} from '../../../../hooks/useApiWrite';
import {EducationRequestBody} from '../../../../lib/api/RequestBodies/features/applicant/profile/EducationRequestBody';
import {ApiResponseError} from '../../../../lib/api/v1/types';

interface Args {
  applicantId: string;
  onSuccess?: () => void;
  onError?: (error?: ApiResponseError) => void;
}

export const useApplicantEducation = ({applicantId, onError, onSuccess}: Args) => {
  const {makeManualRequestWithParams, isLoading, error} = useApiWrite({onError, onSuccess});
  const endpoint = `/api/v1/applicants/${applicantId}/education`;

  const create = (body: EducationRequestBody) => {
    makeManualRequestWithParams({
      path: endpoint,
      method: 'post',
      body: body,
    });
  };

  const update = (resourceId: string, body: EducationRequestBody) => {
    makeManualRequestWithParams({
      path: `${endpoint}/${resourceId}`,
      method: 'patch',
      body,
    });
  };

  const deleteEntry = (resourceId: string) => {
    makeManualRequestWithParams({
      path: `${endpoint}/${resourceId}`,
      method: 'delete',
    });
  };

  return {
    create,
    update,
    delete: deleteEntry,
    isLoading,
    error,
  };
};
